'use client'

import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { Box, Typography, Paper, Link as MuiLink } from '@mui/material'
import { Link } from '@/lib/i18n/settings'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

export function AccessibilityPage() {
  return (
    <Box component="main" sx={{ maxWidth: 720, mx: 'auto', px: { xs: 2, sm: 3 }, py: { xs: 4, sm: 6 } }}>
      <Typography variant="h4" sx={{ fontWeight: 800, color: 'text.primary', mb: 1.5 }}>
        <Trans>Accessibility</Trans>
      </Typography>
      <Box sx={{ height: 5, width: 56, bgcolor: 'primary.main', borderRadius: 4, mb: 4 }} />

      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        <Trans>This accessibility statement applies to the MedConnect patient platform.</Trans>
      </Typography>

      <Paper elevation={0} sx={{ p: 3, mb: 4, borderRadius: 3, bgcolor: 'info.lighter', border: '1px solid', borderColor: 'info.light' }}>
        <Typography variant="subtitle1" fontWeight={700} color="text.primary">
          <Trans>Compliance rate</Trans>:{' '}
          <Box component="span" sx={{ color: 'info.main' }}>
            85 %
          </Box>
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          <Trans>Standard</Trans>: RGAA 4.0
        </Typography>
        <Typography variant="body2" color="text.secondary">
          <Trans>Evaluation date</Trans>: 2026-03-27
        </Typography>
      </Paper>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" fontWeight={700} color="text.primary" sx={{ mb: 1 }}>
          <Trans>Accessibility status</Trans>
        </Typography>
        <Typography variant="body1" color="text.secondary">
          <Trans>The platform has been audited according to the RGAA 4.0 standard. Identified non-conformities are being corrected progressively.</Trans>
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" fontWeight={700} color="text.primary" sx={{ mb: 1 }}>
          <Trans>Contact</Trans>
        </Typography>
        <Typography variant="body1" color="text.secondary">
          <Trans>If you encounter an accessibility issue, please contact us:</Trans>
        </Typography>
        <MuiLink href="mailto:info@promotal-medconnect.com" sx={{ mt: 1, display: 'inline-block' }}>
          info@promotal-medconnect.com
        </MuiLink>
      </Box>

      <Box component="nav" aria-label={t`Navigation`}>
        <MuiLink component={Link} href="/" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
          <ArrowBackIcon sx={{ fontSize: 18 }} />
          <Trans>Back to home</Trans>
        </MuiLink>
      </Box>
    </Box>
  )
}
